<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Open Category COE Depository</h1>
    <app-navpath />
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="form"
      (updateFields_child)="updateFields()"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn add-btn"
        (click)="addEntry()"
        [disabled]="lockBtn"
      >
        <fa-icon [icon]="'plus'" class="mr-1" />Add
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="clearForm()"
      >
        <fa-icon [icon]="'trash'" class="mr-1" />Clear
      </button>
      <button
        class="shorter-btn misc-btn"
        (click)="moveOrRetrieve()"
        [disabled]="lockBtn"
      >
        <fa-icon [icon]="'exchange-alt'" class="mr-1" />Move/Retrieve
      </button>
    </div>
  </div>
</section>
